<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.wageAverage.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">総賃金額</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.regularMaleWage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.nonRegularMaleWage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleWage" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.regularFemaleWage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.nonRegularFemaleWage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleWage" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table02-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">対象人数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.regularMaleCount" :unit="this.unit2"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.nonRegularMaleCount" :unit="this.unit2"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleCount" :unit="this.unit2"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.regularFemaleCount" :unit="this.unit2"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="wageAverage.nonRegularFemaleCount" :unit="this.unit2"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleCount" :unit="this.unit2"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table02-->

    </div><!--/human-capitalt-data-wrap-->

    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table02">
        <p class="l-formGroup__label u-mb10">年間平均賃金</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50px;">
            <col>
            <col>
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcRegularMaleWageAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcNonRegularMaleWageAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementWageAverageMale" :unit="this.unit"/></strong></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcRegularFemaleWageAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.calcNonRegularFemaleWageAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementWageAverageFemale" :unit="this.unit"/></strong></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
    
      <div class="human-capitalt-data-wrap__arrow"></div>
    
      <div class="human-capitalt-data-wrap__results is-harf">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            賃金差異
            <strong><Currency :value="this.calcAchievementWageAverageDiff"/></strong>%
          </div>
        </div>
      </div>
      
    </div><!--/human-capitalt-data-wrap-->

    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(wageAverage.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(wageAverage.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の年間平均賃金データ
    wageAverage: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '千円',
      unit2:'名',
      unit3: '％',
    }
  },
  computed: {
    sumOfMaleWage() {
      if ( !(this.wageAverage.regularMaleWage!=null && this.wageAverage.nonRegularMaleWage!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleWage).length * String(this.wageAverage.nonRegularMaleWage).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleWage) || isNaN(this.wageAverage.nonRegularMaleWage)) {
        return null;
      }else{
        return Number(this.wageAverage.regularMaleWage) + Number(this.wageAverage.nonRegularMaleWage);
      }
    },
    sumOfFemaleWage() {
      if ( !(this.wageAverage.regularFemaleWage!=null && this.wageAverage.nonRegularFemaleWage!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleWage).length * String(this.wageAverage.nonRegularFemaleWage).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleWage) || isNaN(this.wageAverage.nonRegularFemaleWage)) {
        return null;
      }else{
        return Number(this.wageAverage.regularFemaleWage) + Number(this.wageAverage.nonRegularFemaleWage);
      }
    },
    sumOfMaleCount() {
      if ( !(this.wageAverage.regularMaleCount!=null && this.wageAverage.nonRegularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleCount).length * String(this.wageAverage.nonRegularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleCount) || isNaN(this.wageAverage.nonRegularMaleCount)) {
        return null;
      }else{
        return Number(this.wageAverage.regularMaleCount) + Number(this.wageAverage.nonRegularMaleCount);
      }
    },
    sumOfFemaleCount() {
      if ( !(this.wageAverage.regularFemaleCount!=null && this.wageAverage.nonRegularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleCount).length * String(this.wageAverage.nonRegularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleCount) || isNaN(this.wageAverage.nonRegularFemaleCount)) {
        return null;
      }else{
        return Number(this.wageAverage.regularFemaleCount) + Number(this.wageAverage.nonRegularFemaleCount);
      }
    },
    /**
     * 年間平均賃金（男性・正社員）算出処理
     */
    calcRegularMaleWageAverage() {
      if ( !(this.wageAverage.regularMaleWage!=null && this.wageAverage.regularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularMaleWage).length * String(this.wageAverage.regularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularMaleWage) || isNaN(this.wageAverage.regularMaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.regularMaleCount == 0 ) return null;
        if ( this.wageAverage.regularMaleWage == 0 ) return 0;
        let val = (this.wageAverage.regularMaleWage / this.wageAverage.regularMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（男性・非正規社員）算出処理
     */
    calcNonRegularMaleWageAverage() {
      if ( !(this.wageAverage.nonRegularMaleWage!=null && this.wageAverage.nonRegularMaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.nonRegularMaleWage).length * String(this.wageAverage.nonRegularMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.nonRegularMaleWage) || isNaN(this.wageAverage.nonRegularMaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.nonRegularMaleCount == 0 ) return null;
        if ( this.wageAverage.nonRegularMaleWage == 0 ) return 0;
        let val = (this.wageAverage.nonRegularMaleWage / this.wageAverage.nonRegularMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（女性・正社員）算出処理
     */
    calcRegularFemaleWageAverage() {
      if ( !(this.wageAverage.regularFemaleWage!=null && this.wageAverage.regularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.regularFemaleWage).length * String(this.wageAverage.regularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.regularFemaleWage) || isNaN(this.wageAverage.regularFemaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.regularFemaleCount == 0 ) return null;
        if ( this.wageAverage.regularFemaleWage == 0 ) return 0;
        let val = (this.wageAverage.regularFemaleWage / this.wageAverage.regularFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 年間平均賃金（女性・非正規社員）算出処理
     */
    calcNonRegularFemaleWageAverage() {
      if ( !(this.wageAverage.nonRegularFemaleWage!=null && this.wageAverage.nonRegularFemaleCount!=null) ) {
        return null;
      }else if ( String(this.wageAverage.nonRegularFemaleWage).length * String(this.wageAverage.nonRegularFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.wageAverage.nonRegularFemaleWage) || isNaN(this.wageAverage.nonRegularFemaleCount)) {
        return null;
      }else{
        if ( this.wageAverage.nonRegularFemaleCount == 0 ) return null;
        if ( this.wageAverage.nonRegularFemaleWage == 0 ) return 0;
        let val = (this.wageAverage.nonRegularFemaleWage / this.wageAverage.nonRegularFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（男性）算出処理
     */
    calcAchievementWageAverageMale() {
      if ( !(this.sumOfMaleWage!=null && this.sumOfMaleCount!=null) ) {
        return null;
      }else if ( String(this.sumOfMaleWage).length * String(this.sumOfMaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfMaleWage) || isNaN(this.sumOfMaleCount)) {
        return null;
      }else{
        if ( this.sumOfMaleCount == 0 ) return null;
        if ( this.sumOfMaleWage == 0 ) return 0;
        let val = (this.sumOfMaleWage / this.sumOfMaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（女性）算出処理
     */
    calcAchievementWageAverageFemale() {
      if ( !(this.sumOfFemaleWage!=null && this.sumOfFemaleCount!=null) ) {
        return null;
      }else if ( String(this.sumOfFemaleWage).length * String(this.sumOfFemaleCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfFemaleWage) || isNaN(this.sumOfFemaleCount)) {
        return null;
      }else{
        if ( this.sumOfFemaleCount == 0 ) return null;
        if ( this.sumOfFemaleWage == 0 ) return 0;
        let val = (this.sumOfFemaleWage / this.sumOfFemaleCount); // 小数点以下１まで表示なので10
        return Math.round(val);
      }
    },
    /**
     * 実績　年間平均賃金（賃金差異）算出処理
     */
    calcAchievementWageAverageDiff() {
      if ( !(this.calcAchievementWageAverageFemale!=null && this.calcAchievementWageAverageMale!=null) ) {
        return null;
      }else if ( String(this.calcAchievementWageAverageFemale).length * String(this.calcAchievementWageAverageMale).length == 0) {
        return null;
      }else if ( isNaN(this.calcAchievementWageAverageFemale) || isNaN(this.calcAchievementWageAverageMale)) {
        return null;
      }else{
        if ( this.calcAchievementWageAverageMale == 0 ) return null;
        if ( this.calcAchievementWageAverageFemale == 0 ) return 0;
        let val = (this.calcAchievementWageAverageFemale / this.calcAchievementWageAverageMale) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
  },
  watch: {
    wageAverage() {
      this.inputWageAverage();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputWageAverage() {
      this.$emit("change-wage-average-detail", {
        wageAverage: this.wageAverage,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
